import { gql } from "@apollo/client";

export const CREATE_MANUFACTURER = gql`
  mutation CreateManufacturer($input: CreateManufacturerInput!) {
    createManufacturer(input: $input)
  }
`;